module.exports = __webpack_public_path__ + "assets/img/3.4897066b.png";